import { Box, type Tokens } from '@grammarly/design-system'

import styles from './BouncingDot.module.scss'

export interface BouncingDotProps {
  /**
   * Background color for the dot. If not provided, uses CSS default.
   */
  bgColor?: Tokens.CoreColors | Tokens.SemanticColors
}

/**
 * Loading dot
 * @returns A dot with bounce animation
 */
export function BouncingDot({ bgColor }: BouncingDotProps) {
  return <Box className={styles.bouncingDot} as="div" bgColor={bgColor} />
}
